// NoticeListPage.js - PushNotificationManager import 및 컴포넌트 제거
import React, { useEffect, useState, useCallback } from 'react';
import api from '../api/axios';
import {
  Paper,
  Typography,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Stack,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Announcement as AnnouncementIcon } from '@mui/icons-material';
import PullToRefresh from 'react-simple-pull-to-refresh';

function NoticeListPage({ user }) {
  const [notices, setNotices] = useState([]);
  const navigate = useNavigate();

  const fetchNotices = useCallback(async () => {
    try {
      const res = await api.get('/notices');
      setNotices(res.data);
    } catch {
      setNotices([]);
    }
  }, []);

  useEffect(() => {
    fetchNotices();
  }, [fetchNotices]);

  // Pull-to-Refresh 핸들러
  const handleRefresh = useCallback(async () => {
    await fetchNotices();
  }, [fetchNotices]);

  return (
    <PullToRefresh
      onRefresh={handleRefresh}
      pullingContent={
        <Box sx={{ textAlign: "center", py: 2, color: "#666" }}>
          ↓ 당겨서 새로고침
        </Box>
      }
      refreshingContent={
        <Box sx={{ textAlign: "center", py: 2, color: "#1976d2" }}>
          새로고침 중...
        </Box>
      }
    >
    <Box sx={{ pt: { xs: 2, sm: 3 }, pb: 2, px: 2, maxWidth: 700, mx: 'auto' }}>
      {/* 모바일은 헤더에 페이지 제목이 표시되므로 본문 제목을 숨기고, 관리자 등록 버튼만 남긴다 */}
      <Box sx={{ display: { xs: user?.role === 'ADMIN' ? 'flex' : 'none', sm: 'flex' }, alignItems: 'center', justifyContent: { xs: 'flex-end', sm: 'space-between' }, mb: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold', display: { xs: 'none', sm: 'flex' }, alignItems: 'center', gap: 1 }}>
          <AnnouncementIcon sx={{ color: 'primary.main' }} />
          학원 공지사항
        </Typography>

        {user?.role === 'ADMIN' && (
          <Button
            variant="contained"
            size="small"
            onClick={() => navigate('/notice/new')}
          >
            공지 등록
          </Button>
        )}
      </Box>

      {notices.length > 0 ? (
        <Stack spacing={2}>
          {notices.map((notice) => (
            <Card
              key={notice.id}
              sx={{
                borderRadius: 2,
                boxShadow: 2,
                transition: '0.2s',
                '&:hover': { boxShadow: 5, transform: 'translateY(-3px)' },
              }}
            >
              <CardActionArea onClick={() => navigate(`/notice/${notice.id}`)}>
                <CardContent>
                  <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                    {notice.title}
                  </Typography>

                  <Typography variant="body2" color="text.secondary">
                    작성자: {notice.creator?.name || '관리자'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    작성일: {notice.createdAt && new Date(notice.createdAt).toLocaleString('ko-KR')}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Stack>
      ) : (
        <Paper sx={{ py: 5, textAlign: 'center', color: 'text.secondary' }}>
          <Typography>공지사항이 없습니다.</Typography>
        </Paper>
      )}
    </Box>
    </PullToRefresh>
  );
}

export default NoticeListPage;